import React from 'react';
import { Box, Button } from '@mui/material';
import { PhotoCamera } from '@mui/icons-material';
import ExportButtons from './ExportButtons';

/**
 * ActionPanel component for top action buttons 
 */
const ActionPanel = ({ tableData, filteredData, onSaveTransactions, onReceiptUpload, onLoadData }) => {
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      onReceiptUpload(file);
    }
    // Reset the input to allow uploading the same file again
    event.target.value = '';
  };

  return (
    <Box sx={{ display: 'flex', gap: 2, mb: 2, width: '100%', justifyContent: 'space-between' }}>
      <ExportButtons tableData={tableData} filteredData={filteredData} />
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button
          variant="outlined"
          component="label"
          startIcon={<PhotoCamera />}
          color="secondary"
        >
          Upload Receipt
          <input
            type="file"
            hidden
            accept="image/*"
            onChange={handleFileUpload}
          />
        </Button>
        <Button
          variant="outlined"
          onClick={onLoadData}
          sx={{ mr: 1 }}
        >
          Load Data
        </Button>
        <Button
          variant="contained"
          onClick={onSaveTransactions}
        >
          Save All
        </Button>
      </Box>
    </Box>
  );
};

export default ActionPanel;